// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import DelayedTextInput from './delayed-text-input';
import { SearchIcon } from '../icons';
import cssInJS from './css';

export default class SearchBox extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
  };

  static defaultProps = {
    placeholder: 'Search your data...',
  };

  render() {
    const { styles } = SearchBox;

    return (
      <div className={cx(this.props.className, styles.searchContainer)}>
        <DelayedTextInput
          className={styles.search}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onValueChange={this.handleValueChange}
          ref={this.bindInput}
        />
        <div className={styles.searchIcon}>
          <SearchIcon width="18" />
        </div>
      </div>
    );
  }

  handleValueChange = (value) => {
    this.props.onChange(value);
  };

  bindInput = (node) => {
    this._textInput = node;
  };

  focus() {
    if (this._textInput) {
      this._textInput._input.focus();
    }
  }
}

const styles = cssInJS({
  searchContainer: {
    height: 30,
    boxSizing: 'border-box',
    position: 'relative',
    zIndex: 1,
    backgroundColor: '#fff',
  },

  searchIcon: {
    position: 'absolute',
    right: 3,
    top: 5,
    width: 20,
  },

  search: {
    width: '100%',
    border: '1px solid #d9d9d9',
    padding: '6px',
    paddingRight: 26,
    borderRadius: 5,
    boxSizing: 'border-box',
    overflow: 'hidden',
    outline: 'none',
    fontSize: 13,
    lineHeight: '1.2',
  },
});

SearchBox.styles = styles;
